<div
  class="card-custom shadow flex flex-row items-start justify-between bg-white"
>
  @if(isLoading()){
  <div class="bg-white rounded shadow-xl rounded-xl">
    <chl-loader
      class="!absolute !top-1/2 !left-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>
  }@else {
  <!--begin::Number-->

  <div class="flex flex-col">
    <div class="md:text-2xl font-bold text-info text-left">
      @if(config()?.data){
        @if (config()?.label === 'TOTAL_CLAIMS' || config()?.label === 'PENDING_CLAIMS' || config()?.label === 'APPROVED_CLAIMS' || config()?.label === 'REJECTED_CLAIMS' || config()?.label === 'NUMBER_OF_CLAIMANTS') {
            {{ config()?.data | number:'1.0-0' }}
        } @else {
          {{ config()?.data | numericFormatter }}
        }
      @if (config()?.unit) {
      {{ "KPI." + config()?.unit! | translate }}
      }

      }@else{ - }
    </div>
    <!--end::Number-->
    <!--begin::Label-->
    <div class="font-semibold text-left text-gray-400">
      {{ "KPI." + config()?.label | translate }}
      @if (config()?.label === 'TOTAL_FRAUD_SAVINGS') {
        <button
          type="button"
          class="inline-flex items-center justify-center p-0 border-0 bg-transparent text-gray-400 cursor-pointer"
          (click)="savingsInfoPopover.toggle($event)"
          aria-label="More info">
          <i class="fa fa-solid fa-circle-info"></i>
        </button>
        <p-popover #savingsInfoPopover [dismissable]="false" [focusOnShow]="false" styleClass="rule-tooltip-wide">
          <span>{{ 'KPI.SAVINGS_CALCULATED_TOOLTIP' | translate }}</span>
        </p-popover>
      }
      @if (config()?.label === 'SUSPICIOUS_CLAIMS') {
        <button
          type="button"
          class="inline-flex items-center justify-center p-0 border-0 bg-transparent text-gray-400 cursor-pointer"
          (click)="suspiciousInfoPopover.toggle($event)"
          aria-label="More info">
          <i class="fa fa-solid fa-circle-info"></i>
        </button>
        <p-popover #suspiciousInfoPopover [dismissable]="false" [focusOnShow]="false" styleClass="rule-tooltip-wide">
          <span>{{ 'KPI.SUSPICIOUS_CLAIMS_TOOLTIP' | translate }}</span>
        </p-popover>
      }
      @if (config()?.label === 'FRAUDULENT_CLAIMS') {
        <button
          type="button"
          class="inline-flex items-center justify-center p-0 border-0 bg-transparent text-gray-400 cursor-pointer"
          (click)="fraudulentInfoPopover.toggle($event)"
          aria-label="More info">
          <i class="fa fa-solid fa-circle-info"></i>
        </button>
        <p-popover #fraudulentInfoPopover [dismissable]="false" [focusOnShow]="false" styleClass="rule-tooltip-wide">
          <span>{{ 'KPI.FRAUDULENT_CLAIMS_TOOLTIP' | translate }}</span>
        </p-popover>
      }
    </div>
  </div>
  <i [ngClass]="config()?.icon" class="text-xl md:text-2xl text-gray-400"></i>
  <!--end::Label-->
  }
</div>
